import { CONSENT_TRAIT, EVENT, TRAITS } from '@/features/dataSources/components/createDataSource/constants';
import { TraitValue } from '@/features/dataSources/components/createDataSource/types';
import { useWorkspace } from '@/features/workspaces/hooks';
import { Input } from '@/lib';
import { Select } from '@/lib/Selects';
import { ISelectItem } from '@/models/select';
import { useAppSelector } from '@/reducers';
import { useGetTraitsQuery } from '@/services/endpoints/traits';
import { generateSlug } from '@/utils';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type TraitInputProps = {
  option: ISelectItem;
  error?: string;
  value?: TraitValue;
  onChange: (value: TraitValue) => void;
};

export const TraitInput: FC<TraitInputProps> = ({ value, option, error, onChange }) => {
  const { t } = useTranslation('data_source_edit');
  const workspace = useWorkspace();

  const { data } = useGetTraitsQuery({ workspaceId: workspace.id });

  const dataType = (useAppSelector((state) => state.dataSources.edit?.dataSource?.configuration) as { type?: string } | undefined)?.type;

  const traitList: ISelectItem[] = [];

  if (data) {
    const customerTrait = data.customer.map((trait) => ({
      id: trait.id,
      label: trait.displayName,
    }));

    traitList.push(...customerTrait);

    if (dataType === EVENT) {
      const eventTrait = data.event.map((trait) => ({
        id: trait.id,
        label: trait.displayName,
      }));
      traitList.push(...eventTrait);
    }
  }

  switch (option.id) {
    case TRAITS.MAP_TO_TRAIT:
      return (
        <Select
          items={traitList}
          value={traitList.find((trait) => trait.id === value?.id) || undefined}
          onChange={(e: any) => onChange({ id: e.id, displayValue: e.label })}
          error={error}
        />
      );
    case TRAITS.CUSTOM_TRAIT:
      return (
        <Input
          type='text'
          className='h-12 border-secondary-border'
          value={value?.displayValue}
          onChange={(e) => onChange({ id: generateSlug(e.target.value) ?? e.target.value, displayValue: e.target.value })}
          errorMsg={error}
        />
      );
    case TRAITS.CONSENT_TRAIT:
      return (
        <Input
          type='text'
          className='h-12 border-secondary-border'
          value={value?.displayValue}
          placeholder={t('file.map_column.consent_value')}
          onChange={(e) => onChange({ id: CONSENT_TRAIT, displayValue: e.target.value })}
          errorMsg={error}
        />
      );
    case TRAITS.IGNORE_COLUMN:
      return <></>;
    default:
      return <></>;
  }
};
